<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const props = defineProps({
    statusMessage: {
      type: String,
      default: null
    }
  });
</script>

<template>
  <p v-if="props.statusMessage" class="jwx-toolbar-header__meta"><span class="jwx-page__meta-label">{{ t('common.statusMessage') }}</span> {{ props.statusMessage }}</p>
</template>